import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MerchantPolicyEditor from './MerchantPolicyEditor';
export default function TransferControlPage() {
    const user = useSelector(state => state.MyData);
    const navigate = useNavigate();
    return <div style={{ width:'100%', padding:'80px 24px 32px' }}><MerchantPolicyEditor mode="control" role={user?.role} actorId={user?.admin_id} onLogin={() => navigate('/login')} /></div>;
}
